import type { FaireProductEntity } from "../../entity_types/product";

export const p_nat8nvr67c: FaireProductEntity = {
  token: "p_nat8nvr67c",
  type: "product",
  name: "3D Y2K MULTI CARGO PANTS",
  brandToken: "b_kmqjsus8ac",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/752c136617cd94afdf6521cfaa280e86f0cc3183eb94326fecb219f82ebf722f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d547f543808a606853822c44c0742b7f530fe2186a79ec9387630d58409d925.jpeg",
    "https://cdn.faire.com/fastly/d5bdd8988cd6c8970902efc22e59e5972e2c76a2c3d8033fcb4ad7a7c7335b46.jpeg",
    "https://cdn.faire.com/fastly/1307da19e802c054dc5a1d143fc0fe13577391f0a32df4bfffb24f89e827bbd6.jpeg",
    "https://cdn.faire.com/fastly/eede200cd45bbcfb6ecca5efe7fb370bd474f842acf9356df5eb311fdb6dfe32.jpeg",
    "https://cdn.faire.com/fastly/cb0a9fbea3fe63243249948dbd9ec58774095bdd0afae96939c707c3148c4ec8.jpeg",
    "https://cdn.faire.com/fastly/57f75cbb9e9f5699237db6e677072d07ee77842c70e71c464932877aefd9984f.jpeg",
    "https://cdn.faire.com/fastly/3f9ef647fe684834fdbae181897740b32a7706b030830b478849c1cf1828700d.jpeg",
    "https://cdn.faire.com/fastly/c12293ea1889a7a8dd1239d26dc6046b0cd6a6f48de4025b92de72e22ea0436f.jpeg",
    "https://cdn.faire.com/fastly/5eae1aaba841bdd276e8d1adc34e4ba00acd8920dac53203d7396da8b3f77421.jpeg",
  ],
  priceDollars: 34.64,
  description:
    'A woven pants with multi cargo pockets. Featuring  a simple and relaxing silhouette, an adjustable drawcord at the waist, side pockets and one back single welt pocket. \n\nSIZE M / WAIST(ROUND MEASURE) 33" / INSEAM 30 1/4" / BOTTOM OPENING(HALF MEASURE)  8 1/2"\n',
  tags: [],
  msrpDollars: 69.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:08.105Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
